import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ReportData {
  opponentTeam: string;
  userTeam: string;
  opponentStrengths: string[];
  opponentWeaknesses: string[];
  reportType: 'team' | 'player' | 'insights';
}

interface ReportContextType {
  reportData: ReportData | null;
  setReportData: (data: ReportData) => void;
  clearReportData: () => void;
}

const ReportContext = createContext<ReportContextType | undefined>(undefined);

interface ReportProviderProps {
  children: ReactNode;
}

export const ReportProvider: React.FC<ReportProviderProps> = ({ children }) => {
  const [reportData, setReportData] = useState<ReportData | null>(null);

  const clearReportData = () => {
    setReportData(null);
  };

  return (
    <ReportContext.Provider value={{ reportData, setReportData, clearReportData }}>
      {children}
    </ReportContext.Provider>
  );
};

export const useReport = (): ReportContextType => {
  const context = useContext(ReportContext);
  if (context === undefined) {
    throw new Error('useReport must be used within a ReportProvider');
  }
  return context;
}; 